import Load from 'components/Load';
import PrivateRoute from 'components/PrivateRoute';
import React from 'react';
import basePath from 'utils/basePath';

const AsyncPayoutContainer = Load(
  () =>
    import(/* webpackChunkName: "host-payout-methods" */ './containers/Payout'),
);

const HostPayoutRoutes = [
  <PrivateRoute
    key={'host-payout'}
    path={`${basePath}/host/payout`}
    component={AsyncPayoutContainer}
  />,
];

export default HostPayoutRoutes;
